<script setup>
import { useBuildingStore } from '@/store/building'
import { useSortStore } from '@/store/sort'
import { useFilterStore } from '@/store/filter'
import { usePlayerStore } from '@/store/players'

import UnitFilters from '@/components/unit/UnitFilters.vue'
import UnitsGrid from '@/components/unit/UnitsGrid.vue'
import FavouriteList from '../favourites/FavouriteList.vue'

const playerStore = usePlayerStore()

const buildingStore = useBuildingStore()

const filtersStore = useFilterStore()
const sortStore = useSortStore()

const buildings = buildingStore.buildings

onMounted(() => {
    if (playerStore.apartmentChooser) {
        playerStore.apartmentChooser.currentUnitId = null
    }

    if (import.meta.client) {
        sortStore.initializeSort()
        filtersStore.initializeFilter(true)
    }
})

const onUnitSelected = (unit) => {
    const building = buildings.find((b) => b.id === unit.buildingId)
    playerStore.buildingChooser.select(building.publicId)
    playerStore.apartmentChooser.select(unit.unitId)
}

const listOrGrid = ref('list')
</script>
<template>
    <v-container fluid class="unit-list-heading-bar dynamic-max-width">
        <v-row>
            <v-col class="heading-col" cols="12" sm="6" md="6" lg="6" xl="6">
                <slot></slot>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="filters-col">
                <div class="d-flex align-center justify-md-end justify-space-between">
                    <Client-Only>
                        <UnitFilters />
                    </Client-Only>
                    <v-btn-group variant="outlined" size="small" density="compact" class="ml-3">
                        <v-btn
                            value="list"
                            class="filters-btn"
                            :class="{ active: listOrGrid === 'list' }"
                            @click="listOrGrid = 'list'"
                        >
                            <v-icon class="d-inline d-md-none mr-1">
                                mdi-format-list-bulleted
                            </v-icon>
                            <span class="d-none d-md-inline text-capitalize">{{
                                $t('priceList')
                            }}</span>
                        </v-btn>
                        <v-btn
                            value="grid"
                            class="filters-btn"
                            :class="{ active: listOrGrid === 'grid' }"
                            @click="listOrGrid = 'grid'"
                        >
                            <v-icon class="d-inline d-md-none mr-1"> mdi-view-grid-outline </v-icon>
                            <span class="d-none d-md-inline text-capitalize">{{
                                $t('housingUnits')
                            }}</span>
                        </v-btn>
                    </v-btn-group>
                </div>
            </v-col>
        </v-row>
        <ClientOnly>
            <FavouriteList />
        </ClientOnly>
    </v-container>

    <v-container fluid class="units-list-container">
        <v-row v-if="listOrGrid === `list`">
            <Client-Only>
                <UnitDataTable @selectUnit="onUnitSelected" />
            </Client-Only>
        </v-row>
        <v-row v-if="listOrGrid === `grid`" class="unit-grid-row">
            <Client-Only>
                <UnitsGrid @selectUnit="onUnitSelected" />
            </Client-Only>
        </v-row>
    </v-container>
</template>
<style scoped>
.units-heading {
    font-size: 2em;
    font-weight: 700;
    text-transform: capitalize;
}

.filters-btn.active {
    background: #e2e2e2;
    font-weight: 600;
}

@media screen and (max-width: 960px) {
    .units-list-container {
        padding: 4px;
    }
}

.unit-list-heading-bar {
    margin-top: 20px;
    margin-bottom: 20px;
}

.heading-col {
    padding: 12px 0;
}

.filters-col {
    padding: 12px 0;
}
</style>
